import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { SpinnerService } from './spinner.service';
import { ToastService } from './toast.service';
import { UtilService } from './util.service';
import { HouseFlat, IHouseFlat } from '../models/house-flat.model';
import { environment } from '../../environments/environment';
import { IServerResponse, ServerResponse } from '../models/server-response.model';
import { firstValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HouseFlatCodeService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    public spinnerService: SpinnerService,
    private toastService: ToastService,
    private utilService: UtilService
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR create                               */
  /* -------------------------------------------------------------------------- */
  // region create
  async create(
    neighborhoodId: string,
    houseFlat: HouseFlat,
    showSpinner: boolean = true
  ): Promise<HouseFlat | undefined> {

    let houseFlatUpdated: HouseFlat | undefined = undefined;

    if(showSpinner) {
      this.spinnerService.loading = true;
      this.spinnerService.message = 'Generando nuevo código...';
    }

    try {
      const urlApi = `${environment.urlApi}/neighborhoods/${neighborhoodId}/streets-buildings/${houseFlat.streetBuildingId}/houses-flats/${houseFlat.houseFlatId}/codes`;

      const token = await this.authService.getToken();
      const headers = this.utilService.headers(token);      

      const response = await firstValueFrom(
        this.http.post<IServerResponse<{houseFlat: IHouseFlat}>>(
          urlApi,
          null,
          { headers }
        ).pipe(
          map(res => new ServerResponse<{houseFlat: IHouseFlat}>(res))
        )
      );

      if (response.statusCode === 201) {

        houseFlatUpdated = new HouseFlat(
          response.data!.houseFlat
        );

        this.toastService.show({
          body: response.message,
          classname: 'bg-success text-white'
        });

      }

    } catch (error) {
      console.log('Error:', error);

      this.toastService.show({
        header: 'Error al crear cámara',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });

    } finally {

      if(showSpinner) {
        this.spinnerService.loading = false;
        this.spinnerService.message = '';
      }

    }

    return houseFlatUpdated;
  }
}
